import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getScopesList } from '../../../../slices/thunks';
import { createSelector } from 'reselect';
import SimpleBar from 'simplebar-react';
import { Input, Label, Table } from 'reactstrap';

export const PermissionsForm = ({ form, isEdit, dataRole }) => {
	const dispatch = useDispatch();

	const selectScopesList = createSelector(
		state => state.Scopes.scopesListSelect,
		scopesListSelect => scopesListSelect
	);

	const scopesListSelect = useSelector(selectScopesList);

	const [permissionsForm, setPermissionsForm] = useState({});
	const [filter, setFilter] = useState(''); // Estado para el filtro

	const layout = useMemo(() => {
		if (!scopesListSelect.length) return {};

		let permissionsLayout = {};
		let permissions_form = {};

		let permissions_names = [
			...new Set(
				scopesListSelect.map(scope => {
					permissions_form[scope.value] =
						isEdit &&
						dataRole.scopes.length &&
						dataRole.scopes.includes(scope.value)
							? true
							: false;
					return scope.label.split('.').slice(0, -1).join('.');
				})
			),
		];

		permissions_names.forEach(permission_name => {
			if (permission_name) {
				let permission_scopes = scopesListSelect.filter(scope =>
					scope.label.includes(permission_name)
				);

				permissionsLayout[permission_name] = {
					info: {
						collection_name:
							permission_scopes[
								permission_scopes.findIndex(
									el => el?.item?.collection_name
								)
							]?.item?.collection_name || null,
						api_name:
							permission_scopes[
								permission_scopes.findIndex(el => el?.item?.api_name)
							]?.item?.api_name || null,
					},
					one: permission_scopes.some(
						scope => scope.label === `${permission_name}.one`
					)
						? {
							value: permission_scopes.find(
								scope => scope.label === `${permission_name}.one`
							).value,
							label: permission_scopes.find(
								scope => scope.label === `${permission_name}.one`
							).label,
						}
						: null,
					all: permission_scopes.some(
						scope => scope.label === `${permission_name}.all`
					)
						? {
							value: permission_scopes.find(
								scope => scope.label === `${permission_name}.all`
							).value,
							label: permission_scopes.find(
								scope => scope.label === `${permission_name}.all`
							).label,
						}
						: null,
					create: permission_scopes.some(
						scope => scope.label === `${permission_name}.create`
					)
						? {
							value: permission_scopes.find(
								scope => scope.label === `${permission_name}.create`
							).value,
							label: permission_scopes.find(
								scope => scope.label === `${permission_name}.create`
							).label,
						}
						: null,
					update: permission_scopes.some(
						scope => scope.label === `${permission_name}.update`
					)
						? {
							value: permission_scopes.find(
								scope => scope.label === `${permission_name}.update`
							).value,
							label: permission_scopes.find(
								scope => scope.label === `${permission_name}.update`
							).label,
						}
						: null,
					delete: permission_scopes.some(
						scope => scope.label === `${permission_name}.delete`
					)
						? {
							value: permission_scopes.find(
								scope => scope.label === `${permission_name}.delete`
							).value,
							label: permission_scopes.find(
								scope => scope.label === `${permission_name}.delete`
							).label,
						}
						: null,
				};
			}
		});

		setPermissionsForm(permissions_form);

		return permissionsLayout;
	}, [scopesListSelect]);

	useEffect(() => {
		dispatch(getScopesList());
	}, []);

	useEffect(() => {
		if (!scopesListSelect.length) {
			return;
		}

		form.values.scopes = Object.entries(permissionsForm)
			.filter(([key, value]) => value === true)
			.map(([key, value]) => key);
	}, [permissionsForm]);

	return (
		<SimpleBar style={{ maxHeight: '60vh' }}>
			{/* Filtro de permisos por coincidencia parcial */}
			<div className="mb-3">
				<Label for="permissionFilter">Filtrar permisos:</Label>
				<Input
					type="text"
					id="permissionFilter"
					placeholder="Buscar por nombre..."
					value={filter}
					onChange={(e) => setFilter(e.target.value)}
				/>
			</div>

			<div className='table-responsive'>
				<Table className='align-middle table-nowrap mb-0'>
					<thead>
						<tr>
							<th>
								<Input
									className='form-check-input'
									id='permission'
									type='checkbox'
									name='permission'
									onChange={e => {
										const isChecked = e.target.checked;

										// Filtra solo los permisos visibles que coinciden con el filtro actual
										let filteredPermissionsKeys = Object.entries(layout)
											.filter(([permission_name]) =>
												!filter || permission_name.toLowerCase().includes(filter.toLowerCase())
											)
											.flatMap(([permission_name]) =>
												Object.values(layout[permission_name])
													.map(item => item?.value)
													.filter(Boolean)
											);

										let newPermissionsForm = { ...permissionsForm };

										filteredPermissionsKeys.forEach(key => {
											newPermissionsForm[key] = isChecked;
										});

										setPermissionsForm(newPermissionsForm);
									}}
								/>
								<Label
									className='form-check-label'
									htmlFor='permission'
									style={{
										marginLeft: '5px',
									}}
								>
									Permisos
								</Label>
							</th>
							<th>API</th>
							<th style={{ width: '8%' }}>
								<div className='d-flex flex-column justify-content-center align-items-center'>
									<Label className='form-check-label' htmlFor='one'>One</Label>
									<Input
										className='form-check-input'
										id='one'
										type='checkbox'
										name='one'
										onChange={e => {
											let permissionsKeys = Object.values(layout)
												.map(item => item.one?.value)
												.filter(item => item);

											let newPermissionsForm = {
												...permissionsForm,
											};

											permissionsKeys.forEach(key => {
												newPermissionsForm[key] = e.target.checked;
											});

											setPermissionsForm(newPermissionsForm);
										}}
									/>
								</div>
							</th>
							<th style={{ width: '8%' }}>
								<div className='d-flex flex-column justify-content-center align-items-center'>
									<Label className='form-check-label' htmlFor='all'>All</Label>
									<Input
										className='form-check-input'
										id='all'
										type='checkbox'
										name='all'
										onChange={e => {
											let permissionsKeys = Object.values(layout)
												.map(item => item.all?.value)
												.filter(item => item);

											let newPermissionsForm = {
												...permissionsForm,
											};

											permissionsKeys.forEach(key => {
												newPermissionsForm[key] = e.target.checked;
											});

											setPermissionsForm(newPermissionsForm);
										}}
									/>
								</div>
							</th>
							<th style={{ width: '8%' }}>
								<div className='d-flex flex-column justify-content-center align-items-center'>
									<Label className='form-check-label' htmlFor='create'>Create</Label>
									<Input
										className='form-check-input'
										id='create'
										type='checkbox'
										name='create'
										onChange={e => {
											let permissionsKeys = Object.values(layout)
												.map(item => item.create?.value)
												.filter(item => item);

											let newPermissionsForm = {
												...permissionsForm,
											};

											permissionsKeys.forEach(key => {
												newPermissionsForm[key] = e.target.checked;
											});

											setPermissionsForm(newPermissionsForm);
										}}
									/>
								</div>
							</th>
							<th style={{ width: '8%' }}>
								<div className='d-flex flex-column justify-content-center align-items-center'>
									<Label className='form-check-label' htmlFor='update'>Update</Label>
									<Input
										className='form-check-input'
										id='update'
										type='checkbox'
										name='update'
										onChange={e => {
											let permissionsKeys = Object.values(layout)
												.map(item => item.update?.value)
												.filter(item => item);

											let newPermissionsForm = {
												...permissionsForm,
											};

											permissionsKeys.forEach(key => {
												newPermissionsForm[key] = e.target.checked;
											});

											setPermissionsForm(newPermissionsForm);
										}}
									/>
								</div>
							</th>
							<th style={{ width: '8%' }}>
								<div className='d-flex flex-column justify-content-center align-items-center'>
									<Label className='form-check-label' htmlFor='delete'>Delete</Label>
									<Input
										className='form-check-input'
										id='delete'
										type='checkbox'
										name='delete'
										onChange={e => {
											let permissionsKeys = Object.values(layout)
												.map(item => item.delete?.value)
												.filter(item => item);

											let newPermissionsForm = {
												...permissionsForm,
											};

											permissionsKeys.forEach(key => {
												newPermissionsForm[key] = e.target.checked;
											});

											setPermissionsForm(newPermissionsForm);
										}}
									/>
								</div>
							</th>
						</tr>
					</thead>
					<tbody>
						{Object.entries(layout)
							.filter(([permission_name]) =>
								!filter || permission_name.toLowerCase().includes(filter.toLowerCase())
							)
							.sort((a, b) => {
								const apiNameA = a[1].info.api_name || '';
								const apiNameB = b[1].info.api_name || '';

								if (apiNameA < apiNameB) return -1;
								if (apiNameA > apiNameB) return 1;
								return 0;
							})
							.map(([permission_name]) => (
								<tr key={permission_name}>
									<td>
										<Input
											className='form-check-input'
											id={permission_name}
											type='checkbox'
											name={permission_name}
											onChange={e => {
												let permissionsKeys = Object.values(
													layout[permission_name]
												)
													.map(item => item?.value)
													.filter(item => item);

												let newPermissionsForm = {
													...permissionsForm,
												};

												permissionsKeys.forEach(key => {
													newPermissionsForm[key] = e.target.checked;
												});

												setPermissionsForm(newPermissionsForm);
											}}
										/>
										<Label
											className='form-check-label'
											htmlFor={permission_name}
											style={{
												marginLeft: '5px',
											}}
										>
											{layout[permission_name].info.collection_name || permission_name}
										</Label>
									</td>
									<td>
										{layout[permission_name].info.api_name || '-'}
									</td>
									<td>
										<div className='d-flex flex-column justify-content-center align-items-center'>
											<Input
												className='form-check-input'
												type='checkbox'
												name={layout[permission_name].one?.value}
												disabled={!layout[permission_name].one}
												checked={permissionsForm[layout[permission_name].one?.value]}
												onChange={e => {
													setPermissionsForm(prevState => ({
														...prevState,
														[layout[permission_name].one?.value]: e.target.checked,
													}));
												}}
											/>
										</div>
									</td>
									<td>
										<div className='d-flex flex-column justify-content-center align-items-center'>
											<Input
												className='form-check-input'
												type='checkbox'
												name={layout[permission_name].all?.value}
												disabled={!layout[permission_name].all}
												checked={permissionsForm[layout[permission_name].all?.value]}
												onChange={e => {
													setPermissionsForm(prevState => ({
														...prevState,
														[layout[permission_name].all?.value]: e.target.checked,
													}));
												}}
											/>
										</div>
									</td>
									<td>
										<div className='d-flex flex-column justify-content-center align-items-center'>
											<Input
												className='form-check-input'
												type='checkbox'
												name={layout[permission_name].create?.value}
												disabled={!layout[permission_name].create}
												checked={permissionsForm[layout[permission_name].create?.value]}
												onChange={e => {
													setPermissionsForm(prevState => ({
														...prevState,
														[layout[permission_name].create?.value]: e.target.checked,
													}));
												}}
											/>
										</div>
									</td>
									<td>
										<div className='d-flex flex-column justify-content-center align-items-center'>
											<Input
												className='form-check-input'
												type='checkbox'
												name={layout[permission_name].update?.value}
												disabled={!layout[permission_name].update}
												checked={permissionsForm[layout[permission_name].update?.value]}
												onChange={e => {
													setPermissionsForm(prevState => ({
														...prevState,
														[layout[permission_name].update?.value]: e.target.checked,
													}));
												}}
											/>
										</div>
									</td>
									<td>
										<div className='d-flex flex-column justify-content-center align-items-center'>
											<Input
												className='form-check-input'
												type='checkbox'
												name={layout[permission_name].delete?.value}
												disabled={!layout[permission_name].delete}
												checked={permissionsForm[layout[permission_name].delete?.value]}
												onChange={e => {
													setPermissionsForm(prevState => ({
														...prevState,
														[layout[permission_name].delete?.value]: e.target.checked,
													}));
												}}
											/>
										</div>
									</td>
								</tr>
							))}
					</tbody>
				</Table>
			</div>
		</SimpleBar>
	);
};
